module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "OTEPrep-Alumni-Image.fbc6ad6e.png";